<template>
  <MultiSelect
    taggable
    multiple
    hideCaret
    reposition
    hideSelected
    label="name"
    track-by="_id"
    v-model="tagsFilters"
    :searchable="false"
    class="tag-filters"
    id="customer-filters"
    data-testid="audience-tag-filter"
    :options="selectCompanyTags"
    :show-labels="false"
    openDirection="below"
    tag-placeholder="Add"
    :close-on-select="false"
    @close="updateTags"
    @remove="updateTags"
    :showNoResults="false"
    :internal-search="true"
  >
    <template #placeholder>
      <span class="text-secondary"> <span class="fas fa-hashtag"></span> All tags </span>
    </template>
  </MultiSelect>
</template>

<script>
import MultiSelect from '@/components/Common/MultiSelect'
import { createNamespacedHelpers } from 'vuex'

const TagModule = createNamespacedHelpers('tag')

export default {
  name: 'AudienceTagFilter',
  props: {
    initialTagIds: {
      type: Array
    }
  },
  components: {
    MultiSelect
  },
  data: () => ({
    tagsFilters: [],
    lastEmittedKey: ''
  }),
  mounted() {
    this.prepopulateTags()
  },
  computed: {
    ...TagModule.mapGetters(['selectCompanyTags'])
  },
  methods: {
    tagKey(tags) {
      return tags
        .map((tag) => tag._id.toString())
        .sort()
        .join(',')
    },
    prepopulateTags() {
      if (!this.initialTagIds) return
      this.tagsFilters = this.selectCompanyTags.filter((ct) =>
        this.initialTagIds.includes(ct._id.toString())
      )
      // From the requested ids, not the matched options: a tag missing from the reloaded options
      // still sits in the store's filter, so the next close must emit to drop it.
      this.lastEmittedKey = [...this.initialTagIds].map(String).sort().join(',')
    },
    // Bound to both remove and close, so removing a chip with the dropdown open fires twice.
    updateTags() {
      const key = this.tagKey(this.tagsFilters)
      if (key === this.lastEmittedKey) return
      this.lastEmittedKey = key
      this.$emit('update', this.tagsFilters)
    }
  },
  watch: {
    selectCompanyTags: {
      immediate: true,
      handler() {
        this.prepopulateTags()
      }
    }
  }
}
</script>
